module.exports = __webpack_public_path__ + "static/media/1.100fef3c.jpg";